function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntelligance2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 900",
    style: {
      enableBackground: "new 0 0 900 900",
      display: "none"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    style: {
      opacity: 0.41,
      fill: "#F9E8C2"
    },
    d: "M533.031,515.909L533.031,515.909 c22.236-27.727,35.546-62.92,35.546-101.227c0-89.434-72.5-161.934-161.934-161.934c-89.434,0-161.934,72.5-161.934,161.934 c0,38.307,13.31,73.5,35.546,101.227l0,0v0c2.669,3.327,5.464,6.547,8.382,9.652l7.064,8.135 c21.256,24.477,35.557,53.942,41.763,85.341c2.318,11.727,136.119,10.953,138.587-1.134c6.324-30.974,20.536-60.025,41.535-84.207 l7.064-8.135C527.567,522.457,530.362,519.237,533.031,515.909L533.031,515.909z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1459_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M368.225,189.483c0,0-1.992-23.476,6.336-29.421 c8.328-5.945,11.861-9.064,20.707-7.779s21.392,14.728,21.392,14.728l-1.351,15.776l-3.997,8.89l-13.866,5.823l-18.071,6.637 L368.225,189.483z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_295_",
    style: {
      fill: "#F7F0ED"
    },
    cx: 410.028,
    cy: 779.108,
    rx: 80.071,
    ry: 20.16
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_374_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_391_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_393_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 503.967,
    y1: 588.867,
    x2: 519.845,
    y2: 616.368
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_395_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 564.285,
    y1: 511.472,
    x2: 602.612,
    y2: 533.601
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_397_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 589.608,
    y1: 420.538,
    x2: 632.907,
    y2: 420.538
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_398_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 568.716,
    y1: 327.046,
    x2: 602.612,
    y2: 307.476
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_399_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 502.144,
    y1: 255.368,
    x2: 519.845,
    y2: 224.708
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_400_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 406.783,
    y1: 232.819,
    x2: 406.783,
    y2: 194.413
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_401_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 313.096,
    y1: 258.269,
    x2: 293.72,
    y2: 224.708
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_402_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 249.28,
    y1: 329.604,
    x2: 210.953,
    y2: 307.476
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_404_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 222.925,
    y1: 420.538,
    x2: 180.658,
    y2: 420.538
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_405_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 249.28,
    y1: 511.472,
    x2: 210.953,
    y2: 533.601
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_406_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 10.7956,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 308.508,
    y1: 590.755,
    x2: 293.72,
    y2: 616.368
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_457_",
    style: {
      fill: "#74A5A5",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M406.643,739.225L406.643,739.225c-13.746,0-24.89-11.144-24.89-24.89v-19.492h49.78v19.492 C431.533,728.082,420.389,739.225,406.643,739.225z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_296_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_387_",
    style: {
      fill: "#548E8C",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M475.919,620.401c-3.19,0-5.863-2.214-6.567-5.19c-4.148-3.265-26.132-9.038-63.078-9.038c-36.946,0-58.93,5.773-63.078,9.038 c-0.703,2.976-3.376,5.19-6.567,5.19c-3.726,0-6.747-3.021-6.747-6.747c0-10.106,13.785-14.218,25.796-16.671 c13.585-2.775,31.554-4.304,50.597-4.304c19.043,0,37.012,1.528,50.597,4.304c12.01,2.454,25.795,6.566,25.795,16.671 C482.666,617.38,479.645,620.401,475.919,620.401z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_396_",
    style: {
      fill: "#C0DFE2",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M475.469,614.841v54.869c0,1.466-0.054,2.924-0.18,4.372c-0.405,5.245-1.565,10.283-3.356,15.006 c-1.259,3.32-2.834,6.486-4.687,9.455c-3.31,5.335-7.53,10.058-12.424,13.953c-9.338,7.44-21.159,11.884-34.024,11.884h-28.302 c-19,0-35.742-9.698-45.54-24.416l-0.351-0.54c-3.103-4.768-5.479-10.067-6.972-15.708c-0.063-0.243-0.126-0.486-0.18-0.729 c-0.765-3.068-1.277-6.225-1.493-9.464c-0.09-1.26-0.135-2.537-0.135-3.814v-54.869H475.469z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_380_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_385_",
    style: {
      fill: "#9DC4C4"
    },
    d: "M475.095,636.882v16.913c-10.373,6.037-31.694,8.987-64.611,8.987 c-37.578,0-62.093-3.841-73.032-11.443V637.35c3.851,4.75,18.272,14.637,73.032,14.637 C477.416,651.987,473.71,639.077,475.095,636.882z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_382_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_383_",
    style: {
      fill: "#9DC4C4"
    },
    d: "M475.095,658.923v16.913c-10.373,6.036-31.694,8.987-64.611,8.987 c-37.578,0-62.093-3.841-73.032-11.443v-13.989c3.851,4.75,18.272,14.637,73.032,14.637 C477.416,674.028,473.71,661.118,475.095,658.923z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_384_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    style: {
      fill: "#9DC4C4"
    },
    d: "M410.488,695.619v2.96c0,4.336-3.563,7.845-7.899,7.773 c-25.298-0.396-44.019-2.708-55.984-6.927c-3.103-4.768-5.479-10.067-6.972-15.708c-0.063-0.243-0.126-0.486-0.18-0.729 C345.562,688.053,362.592,695.619,410.488,695.619z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_378_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_381_",
    style: {
      fill: "#9DC4C4"
    },
    d: "M475.469,613.289v16.913c-10.373,6.036-31.694,8.987-64.611,8.987 c-37.578,0-62.466-2.317-73.406-9.918l0.373-15.514c3.851,4.75,18.271,14.637,73.032,14.637 C477.79,628.394,474.083,615.484,475.469,613.289z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    style: {
      fill: "#9DC4C4"
    },
    d: "M475.095,654.578v15.132c0,1.466-0.054,2.924-0.18,4.372 c-0.396,5.245-1.556,10.283-3.356,15.006c-1.259,3.32-2.834,6.486-4.687,9.455c-3.302,5.335-7.521,10.058-12.424,13.953 c-9.338,7.44-21.15,11.884-34.024,11.884h-28.294c-19.009,0-35.742-9.698-45.548-24.416c-3.275-4.912-5.776-10.391-7.323-16.247 c-0.864-3.293-1.43-6.693-1.673-10.193c-0.09-1.26-0.135-2.537-0.135-3.814v-15.132c0,1.277,0.045,2.555,0.135,3.814 c0.243,3.5,0.81,6.9,1.673,10.193c1.548,5.857,4.048,11.335,7.323,16.247c9.806,14.718,26.539,24.416,45.548,24.416h28.294 c12.874,0,24.686-4.444,34.024-11.884c4.903-3.895,9.122-8.618,12.424-13.953c1.853-2.969,3.428-6.135,4.687-9.455 c1.799-4.723,2.96-9.761,3.356-15.006C475.041,657.502,475.095,656.044,475.095,654.578z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M475.464,614.841v54.87c0,1.466-0.054,2.924-0.18,4.372c-0.405,5.245-1.565,10.283-3.356,15.006 c-1.259,3.32-2.834,6.486-4.687,9.455c-3.31,5.335-7.53,10.058-12.424,13.953c-9.338,7.44-21.159,11.884-34.024,11.884h-28.302 c-19,0-35.742-9.698-45.539-24.416c-3.275-4.912-5.776-10.391-7.323-16.247c-0.864-3.293-1.439-6.693-1.673-10.193 c-0.09-1.26-0.135-2.537-0.135-3.814v-54.87H475.464z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    style: {
      fill: "#A1C2C4"
    },
    d: "M365.264,601.068v25.172c-17.372-2.843-28.635-7.422-28.635-12.586 C336.628,608.49,347.892,603.91,365.264,601.068z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    style: {
      fill: "#A1C2C4"
    },
    d: "M406.8,598.036c11.146,0,25.314,1.038,34.67,2.073l-3.633,27.552 c-9.356,1.035-19.891,1.61-31.037,1.61c-10.319,0-20.116-0.495-28.941-1.385l-6.049-27.685 C380.636,599.31,396.481,598.036,406.8,598.036z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_475_",
    style: {
      fill: "#A1C2C4"
    },
    d: "M476.971,613.654c0,4.957-10.364,9.374-26.539,12.235v-24.47 C466.607,604.279,476.971,608.696,476.971,613.654z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    style: {
      fill: "#74A5A5"
    },
    d: "M371.73,599.988l6.129,27.898c-4.471-0.45-8.691-0.999-12.595-1.646l-5.676-24.135 C363.11,601.442,367.259,600.437,371.73,599.988z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_468_",
    style: {
      fill: "#74A5A5"
    },
    d: "M453.948,602.085l-3.517,23.803c-3.886,0.684-8.105,1.286-12.595,1.772 l3.817-27.706C446.144,600.441,450.062,601.401,453.948,602.085z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_484_",
    style: {
      fill: "none",
      stroke: "#FFBF40",
      strokeWidth: 8.0967,
      strokeMiterlimit: 10
    },
    d: "M432.351,541.783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    style: {
      fill: "none",
      stroke: "#FFBF40",
      strokeWidth: 8.0967,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M374.26,627.661l-26.932-135.427c-1.858-9.345,2.902-18.971,11.711-22.601c2.813-1.159,5.944-1.705,9.225-1.473 c9.913,0.702,17.989,8.69,18.79,18.595c0.134,1.664,0.069,3.29-0.176,4.858c-0.785,5.026-7.15,6.911-10.453,3.042 c-3.032-3.552-4.862-8.161-4.862-13.197c0-12.084,10.537-21.707,22.924-20.181c8.881,1.094,16.236,7.839,17.549,16.691 c0.573,3.864-0.024,7.601-1.439,10.927c-2.119,4.979-9.267,4.726-11.154-0.346c-0.821-2.208-1.27-4.596-1.27-7.09 c0-11.663,9.817-21.034,21.638-20.3c10.366,0.643,18.701,9.253,19.032,19.634c0.153,4.796-1.355,9.234-3.991,12.783 c-3.116,4.194-9.748,2.819-10.852-2.288c-0.301-1.391-0.459-2.835-0.459-4.316c0-11.663,9.816-21.034,21.638-20.3 c4.399,0.273,8.437,1.982,11.652,4.654c5.422,4.508,7.851,11.69,6.713,18.649l-21.101,128.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_70_",
    style: {
      fill: "#FFEDD9"
    },
    points: "424.412,127.386 417.695,116.352 411.736,121.794 405.347,135.356  405.653,141.34 409.772,147.607 414.291,153.321 421.938,156.443 425.986,143.399  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_307_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_311_",
    style: {
      fill: "#E2F7F5",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M410.723,679.961c-41.555,0-67.142-4.704-76.049-13.982c-3.097-3.226-3.327-6.131-3.282-7.23c0.121-2.979,2.64-5.306,5.613-5.174 c2.664,4.226,15.01,15.59,73.718,15.59c70.714,0,62.584-14.406,64.898-15.38c1.77-0.745,4.904,0.037,6.288,2.679 c1.089,2.079,1.492,5.556-0.642,9.082C475.398,675.246,452.323,679.961,410.723,679.961z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_316_",
    style: {
      fill: "#E2F7F5",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M411.478,695.837c0,3-2.451,5.432-5.452,5.401c-38.347-0.4-62.086-5.089-70.597-13.954c-3.097-3.226-3.327-6.131-3.282-7.23 c0.121-2.979,2.64-5.306,5.613-5.174c2.581,4.094,14.251,14.889,68.368,15.557C409.091,690.474,411.478,692.875,411.478,695.837 L411.478,695.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_312_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_375_",
    style: {
      fill: "#E2F7F5",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M410.859,658.308c-41.555,0-67.142-4.704-76.049-13.982c-3.097-3.226-3.327-6.131-3.282-7.23c0.121-2.979,2.64-5.306,5.613-5.174 c2.664,4.226,15.01,15.59,73.718,15.59c70.714,0,62.584-14.406,64.898-15.38c1.77-0.745,4.904,0.037,6.288,2.679 c1.089,2.079,1.492,5.556-0.642,9.082C475.534,653.593,452.46,658.308,410.859,658.308z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_376_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_377_",
    style: {
      fill: "#74A5A5",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M406.273,634.629c-19.043,0-37.012-1.529-50.597-4.304c-12.01-2.453-26.735-6.566-26.735-16.671c0-3.726,2.961-7.717,5.869-7.987 c3.521,4.674,6.219,5.619,8.525,6.755c5.128,2.525,25.992,8.713,62.938,8.713c36.946,0,58.63-6.067,63.198-8.713 c2.453-1.421,6.083-3.115,10.019-7.501c3.233,2.179,4.638,4.056,4.638,7.782c0,10.106-15.247,15.169-27.257,17.622 C443.285,633.1,425.316,634.629,406.273,634.629z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_379_",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 23.3904,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M295.277,402.574c0-54.608,44.269-98.877,98.877-98.877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_386_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M479.49,604.92c7.304-26.235,20.373-50.736,38.499-71.609l7.064-8.135c2.918-3.104,5.713-6.325,8.382-9.652v0l0,0 c22.236-27.727,35.546-62.92,35.546-101.227c0-89.434-72.5-161.934-161.934-161.934c-89.433,0-161.934,72.5-161.934,161.934 c0,38.307,13.31,73.5,35.546,101.227l0,0v0c2.669,3.327,5.464,6.547,8.382,9.652l7.064,8.135 c18.246,21.011,31.368,45.699,38.643,72.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_721_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M356.718,182.788"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_719_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_720_",
    style: {
      fill: "#F7F0ED",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M448.177,218.435 c-3.88,1.3-8.282-0.189-10.516-3.824l-22.395-36.444c-2.602-4.233-1.279-9.773,2.954-12.375 c4.235-2.605,9.774-1.279,12.375,2.954l22.395,36.444c2.602,4.233,1.279,9.773-2.954,12.375 C449.438,217.932,448.815,218.221,448.177,218.435z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_718_",
    style: {
      fill: "#CE937C",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M423.931,276.443h-39.08 c-12.97,0-21.99-9.111-21.988-20.35l0-1.715h62.472L423.931,276.443z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_543_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M401.458,151.184h8.488c8.862,0,16.045,7.184,16.045,16.045v22.666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_542_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M425.991,177.462v74.471l-62.494,0c-0.34,0-0.607-0.292-0.576-0.631l4.114-45.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1413_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M368.904,179.728c0-21.38,11.288-28.547,32.668-28.547h8.317c8.956,0,16.216,7.26,16.216,16.216v22.495"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_2_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 426.104,177.459 426.104,251.93 363.527,251.93  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M419.823,163.819l1.124,8.299c0.103,0.763,1.124,0.946,1.486,0.266l6.419-12.323l-5.604-3.619L419.823,163.819z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_120_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 424.164,158.62 420.557,164.624 415.309,166.384 400.134,147.904 405.369,138.242  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_708_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_712_",
    style: {
      fill: "#E25959"
    },
    d: "M416.869,173.174h-2.496c-2.434,0-4.407-1.973-4.407-4.407v-1.208 c0-2.434,1.973-4.407,4.407-4.407h2.496c2.434,0,4.407,1.973,4.407,4.407v1.208C421.276,171.2,419.303,173.174,416.869,173.174z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_711_",
    style: {
      fill: "#D34242"
    },
    d: "M410.471,169.163c0.228-0.228,4.838-2.778,4.838-2.778l5.578,2.588l0.475-3.014 l-6.053-2.807l-5.344,2.779v3.407L410.471,169.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_710_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M416.869,173.174h-2.496c-2.434,0-4.407-1.973-4.407-4.407v-1.208c0-2.434,1.973-4.407,4.407-4.407h2.496 c2.434,0,4.407,1.973,4.407,4.407v1.208C421.276,171.2,419.303,173.174,416.869,173.174z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_709_",
    style: {
      fill: "#E25959",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 419.287,172.929 411.955,172.929 405.283,233.39 415.309,243.212 425.336,233.39  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_611_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M400.134,147.904c-1.022,0.45-7.544,3.956-7.544,3.956l14.604,21.051c0.482,0.695,1.547,0.563,1.845-0.229l4.142-11.025 L400.134,147.904z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_704_",
    style: {
      fill: "#640917",
      stroke: "#630B18",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M426.071,254.378 h-62.924c-0.196,0-0.352-0.166-0.339-0.362l0.455-6.852h62.808V254.378z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_703_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M445.962,219.637c-3.988-0.92-6.962-4.491-6.965-8.758l-0.039-42.775c-0.005-4.969,4.019-9,8.988-9.004 c4.972-0.007,9,4.02,9.004,8.988l0.039,42.775c0.005,4.969-4.019,9-8.988,9.004C447.3,219.867,446.617,219.788,445.962,219.637z"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_463_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 438.831,155.981 439.133,176.333 456.95,176.164 456.993,158.286  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_492_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M448.015,165.39v-2.659c-0.406,0.402-0.965,0.51-1.582,0.51h-0.565c-2.709,0-5.126-1.942-5.47-4.628 c-0.417-3.25,2.115-6.03,5.285-6.03h1.502c2.943,0,5.329,2.386,5.329,5.329v7.479 M445.682,157.079 c-0.459,0-0.832,0.373-0.832,0.831c0,0.459,0.373,0.832,0.832,0.832h0.751c0.157,0,0.31,0.016,0.458,0.047 c0.578,0.12,1.124,2.561,1.124,1.972v-2.85c0-0.459-0.372-0.831-0.831-0.831H445.682z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_501_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M439.355,158.757l-3.398-2.112c-1.214-0.754-1.586-2.35-0.832-3.564l0,0c0.75-1.206,2.332-1.583,3.544-0.844l5.523,3.684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M417.819,156.01c6.654,7.142,19.542,9.217,28.912-2.339l13.078-17.523l1.811-2.427c4.125-5.527,2.989-13.351-2.538-17.476 l-18.994-14.178c-5.527-4.126-13.353-2.989-17.478,2.538l-3.596,4.818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_690_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M420.238,107.775l-10.142,13.597h0c-3.764,5.042-5.282,11.065-4.728,16.871"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_689_",
    x: 447.112,
    y: 135.669,
    transform: "matrix(-0.8014 -0.5981 0.5981 -0.8014 730.4097 521.1068)",
    style: {
      fill: "#FCD3B6"
    },
    width: 9.205,
    height: 7.258
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_688_",
    style: {
      fill: "#FCD3B6"
    },
    d: "M432.626,129.58l3.715,2.773c1.853,1.383,4.477,1.002,5.861-0.851l1.837-2.461 l-10.211-7.621l-1.998,2.677C430.535,125.831,430.892,128.286,432.626,129.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M415.621,153.864c9.414,10.593,22.368,11.137,31.191-0.303l13.078-17.523l1.811-2.427c4.125-5.527,2.989-13.351-2.538-17.476 l-18.994-14.178c-5.527-4.126-13.353-2.989-17.478,2.538l-3.596,4.818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_680_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M420.32,107.666l-10.142,13.597l0,0c-3.786,5.071-5.299,11.134-4.718,16.971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1477_",
    style: {
      fill: "#FCD3B6"
    },
    d: "M421.779,118.882l-6.387,8.556l-0.675,0.945 c-2.87,4.183-4.246,8.978-4.246,13.728c0,0.477,0.018,0.963,0.045,1.439c0.018,0.288,0.036,0.585,0.063,0.873l-1.233,2.276 l-3.958,7.323l-5.254-6.387l5.236-9.662l0.135,0.153l-0.018-0.396l-0.135-2.645c0.081-4.597,1.466-9.221,4.228-13.27l0.594-0.828 l8.592-11.506l0.198,0.63L421.779,118.882z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_677_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M436.698,145.577c1.627,1.214,3.93,0.88,5.144-0.747l4.937-6.615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_676_",
    style: {
      fill: "#FFF3E4",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M409.772,116.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_675_",
    style: {
      fill: "#640917",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M434.777,122.784l7.585,5.661c0.698,0.521,1.686,0.377,2.207-0.321l0,0c0.521-0.698,0.377-1.686-0.32-2.207l-7.585-5.661 c-0.698-0.521-1.686-0.377-2.207,0.32l0,0C433.935,121.275,434.079,122.263,434.777,122.784z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_671_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_673_",
    style: {
      fill: "#891F38",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M427.426,90.975c1.254-1.68,3.633-2.026,5.313-0.772c0.034,0.026,0.065,0.055,0.098,0.081c0.485-1.04,1.282-1.987,2.448-2.697 c2.059-1.254,4.7-1.037,6.632,0.405l0,0c1.347,1.005,2.152,2.465,2.366,4.008c2.798,0.65,5.512,1.872,7.962,3.7l30.665,22.886 l-7.407,9.925c-4.091,5.481-11.851,6.609-17.332,2.518l-21.275-15.878c-3.073-2.294-7.33-2.133-10.221,0.385l-6.606,5.752 c-2.212,1.926-5.616,0.002-5.108-2.886l-1.539-6.532l8.813-11.809c1.435-1.923,3.134-3.531,5.006-4.823 C426.446,93.951,426.467,92.26,427.426,90.975z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_670_",
    style: {
      fill: "#640917",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M427.232,95.345c-1.872,1.293-3.571,2.897-5.008,4.822l-8.813,11.809l1.541,6.532c-0.242,1.388,0.414,2.555,1.41,3.176 c0.334,0.209,0.778,0.109,1.014-0.207l11.949-16.011c1.437-1.926,8.263-12.39,14.949-13.361c-0.903,0.189,0.173,0.039,0,0 c-0.108-0.77-0.358-1.519-0.754-2.204c-0.512-0.873-1.25-1.643-2.216-2.2c-1.319-0.761-2.915-0.915-4.396-0.561 c-2.178,0.521-3.423,1.834-4.077,3.253c-0.159-0.118-0.092-0.196-1.651-0.567c-1.446-0.344-3.022,0.16-3.859,1.388 C426.456,92.482,426.466,94.101,427.232,95.345z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_403_",
    style: {
      opacity: 0.41,
      fill: "#E5B683"
    },
    points: "412.382,332.164 414.856,346.385 426.105,360.779  434.741,364.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_612_",
    style: {
      opacity: 0.41,
      fill: "#E5B683"
    },
    points: "462.136,330.053 464.61,344.274 475.025,360.59  484.496,362.717  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_668_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_669_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M427.49,90.982c1.254-1.68,3.633-2.026,5.313-0.772c0.034,0.026,0.065,0.055,0.098,0.081c0.485-1.04,1.282-1.987,2.448-2.697 c2.06-1.254,4.7-1.037,6.632,0.405v0c1.347,1.005,2.152,2.465,2.366,4.007c2.798,0.65,5.512,1.872,7.962,3.7l30.664,22.886 l-7.407,9.925c-4.091,5.481-11.851,6.609-17.332,2.518l-21.275-15.878c-3.073-2.293-7.329-2.133-10.222,0.385l-6.606,5.752 c-2.212,1.926-5.616,0.003-5.108-2.886l-1.539-6.532l8.813-11.809c1.435-1.923,3.134-3.531,5.006-4.823 C426.51,93.957,426.531,92.266,427.49,90.982z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_666_",
    style: {
      fill: "#640917",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M451.146,135.001l4.849,3.619c0.698,0.521,1.686,0.377,2.207-0.321l0,0c0.521-0.698,0.377-1.686-0.321-2.207l-4.849-3.619 c-0.698-0.521-1.686-0.377-2.207,0.321l0,0C450.304,133.492,450.448,134.48,451.146,135.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_657_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M416.61,122.164c2.009-2.692,1.456-6.504-1.237-8.513c-2.692-2.009-6.503-1.456-8.513,1.237c-2.009,2.692-1.456,6.503,1.237,8.513 c0.878,0.655,1.875,1.038,2.89,1.163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_644_",
    style: {
      fill: "#FFF3E4",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M413.235,116.347c-1.095-0.818-2.646-0.592-3.463,0.503"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_643_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 437.989,
    y1: 153.321,
    x2: 432.561,
    y2: 149.768
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_632_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_635_",
    style: {
      fill: "#CE937C"
    },
    d: "M475.304,343.108c-4.978,0-9.529-3.33-10.863-8.37l-21.924-82.813l-14.69,23 c-3.344,5.233-10.297,6.767-15.531,3.424c-5.234-3.343-6.767-10.296-3.424-15.531l23.105-36.175 c3.338-5.226,9.453-7.983,15.582-7.03c6.127,0.956,11.112,5.448,12.699,11.443l25.925,97.925 c1.59,6.004-1.989,12.16-7.993,13.749C477.225,342.986,476.257,343.108,475.304,343.108z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_486_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M440.459,132.941c-0.296,1.602-1.835,2.661-3.437,2.365c-1.602-0.296-2.661-1.835-2.365-3.437 c0.296-1.602,1.835-2.661,3.437-2.365C439.696,129.8,440.755,131.339,440.459,132.941z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_508_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M454.329,142.77c-0.296,1.602-1.835,2.661-3.437,2.365c-1.602-0.296-2.661-1.835-2.365-3.437c0.296-1.602,1.835-2.661,3.437-2.365 C453.566,139.629,454.625,141.168,454.329,142.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_620_",
    style: {
      fill: "#DBAA94"
    },
    d: "M418.216,269.329l20.184-29.61c2.605-3.821,8.477-2.911,9.804,1.519l24.603,88.38 l-9.954-0.873l-20.337-76.819l-17.181,27.033"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_618_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_619_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M475.304,343.108 c-4.978,0-9.529-3.33-10.863-8.37l-21.924-82.813l-14.69,23c-3.344,5.233-10.297,6.767-15.531,3.424 c-5.234-3.343-6.767-10.296-3.424-15.531l23.105-36.175c3.338-5.226,9.453-7.983,15.582-7.03 c6.127,0.956,11.112,5.448,12.699,11.443l25.925,97.925c1.59,6.004-1.989,12.16-7.993,13.749 C477.225,342.986,476.257,343.108,475.304,343.108z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_614_",
    style: {
      fill: "#CE937C",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M443.573,255.917c0.004,0.031-3.035-11.52-3.035-11.52"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_610_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    x1: 462.206,
    y1: 327.912,
    x2: 484.425,
    y2: 324.391
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_588_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1554_",
    style: {
      fill: "#CE937C"
    },
    d: "M368.904,260.783l22.796-33.147c3.689-5.363,10.164-7.854,16.495-6.349 c6.332,1.506,10.991,6.647,11.869,13.096l13.366,98.084c0.839,6.154-3.47,11.823-9.624,12.661 c-0.515,0.07-1.027,0.104-1.533,0.104c-5.537,0-10.36-4.09-11.129-9.728l-10.97-80.5l-10.09,14.326"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#DBAA94"
    },
    d: "M387.942,276.443c6.474-0.75,13.475-14.64,13.475-14.64l10.043,73.7l8.284-8.501 l-11.589-84.204c-0.691-5.019-7.144-6.638-10.123-2.54l-14.007,19.273c-3.428,4.717-10.524,4.52-13.685-0.38l0,0l-4.905,6.258 C365.436,265.411,369.22,277.23,387.942,276.443"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_569_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1490_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M364.218,263.405c0,0,4.225,13.038,21.608,13.038c10.074,0,15.158-15.691,15.158-15.691l10.159,74.751 c0.769,5.638,5.592,9.729,11.129,9.728c0.506,0,1.017-0.034,1.533-0.104c6.154-0.839,10.463-6.507,9.624-12.661l-13.366-98.084 c-0.879-6.449-5.538-11.589-11.869-13.096c-6.33-1.505-12.806,0.986-16.495,6.349l-22.796,33.147"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_566_",
    style: {
      fill: "#CE937C",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M401.1,261.803c0.004,0.031-1.758-13.695-1.758-13.695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_532_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 3.5985,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M437.088,334.737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_496_",
    style: {
      fill: "none",
      stroke: "#FFF0CF",
      strokeWidth: 3.5985,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M428.8,336.661"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_495_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    x1: 410.688,
    y1: 331.203,
    x2: 432.247,
    y2: 324.391
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M452.491,165.39v-2.659c-0.406,0.402-0.965,0.51-1.582,0.51h-0.565c-2.709,0-5.126-1.942-5.47-4.628 c-0.417-3.25,2.115-6.03,5.285-6.03h1.502c2.943,0,5.329,2.386,5.329,5.329v10.229 M450.157,157.079 c-0.459,0-0.832,0.373-0.832,0.831c0,0.459,0.373,0.832,0.832,0.832h0.751c0.157,0,0.31,0.016,0.458,0.047 c0.578,0.12,1.124,2.561,1.124,1.972v-2.85c0-0.459-0.372-0.831-0.831-0.831H450.157z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    style: {
      fill: "#FCD3B6",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M450.157,158.742h0.115c1.225,0,2.218,0.993,2.218,2.218v0c0,1.225-0.993,2.218-2.218,2.218h-0.332"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_541_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_546_",
    style: {
      fill: "#FFFFFF",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M385.471,177.673l-2.704,34.604c-0.09,1.15,1.022,2.022,2.119,1.663c17.443-5.711,29.182-9.168,30.857-9.802 c0.464,0.673,2.508,0.77,5.089,3.448c3.323,3.449,3.183,8.893-0.213,12.271c-1.737,1.728-1.903,0.799-39.834,13.258 c-1.172,0.385-2.378,0.573-3.576,0.573c-3.126,0-6.193-1.285-8.436-3.721c-2.206-2.396-3.187-5.678-2.934-8.924l3.129-44.017"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_540_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_530_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M415.743,204.137v17.998h10.703c0.954,0,1.728,0.774,1.728,1.728v8.423c0,1.792,1.453,3.245,3.245,3.245l0,0 c1.792,0,3.245-1.453,3.245-3.245V221.67c0-9.683-7.85-17.533-17.533-17.533H415.743z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M423.22,222.135c0.954,0,1.728,0.774,1.728,1.728v8.423c0,1.792,1.453,3.245,3.245,3.245l0,0c1.792,0,3.245-1.453,3.245-3.245 V221.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_502_",
    style: {
      fill: "#FFEDD9"
    },
    d: "M419.222,219.637c0,0.15,2.073,3.33,2.073,3.33l4.487,0.307l2.258-0.45 c0,0,0.271-4.425,0-4.425c-0.271,0-7.506-0.823-7.506-0.823L419.222,219.637z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    style: {
      fill: "#FFEDD9",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M419.823,222.135c0.954,0,1.728,0.774,1.728,1.728v8.423c0,1.792,1.453,3.245,3.245,3.245l0,0c1.792,0,3.245-1.453,3.245-3.245 V221.67"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_544_",
    x: 366.426,
    y: 247.164,
    style: {
      fill: "#CE937C",
      stroke: "#CE937C",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    width: 3.599,
    height: 7.791
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_556_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M484.904,324.155 l3.819,15.13l5.879,18.055c0,0,1.896,7.262-5.976,9.146c-5.964,1.428-12.659-2.034-14.608-8.182 c-1.187-3.743-3.985-11.92-3.985-11.92l-4.114-2.459c-0.366-0.219-0.659-0.542-0.841-0.928l-3.583-7.607 c-0.2-0.424-0.255-0.902-0.158-1.361l1.297-6.117L484.904,324.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_586_",
    style: {
      fill: "#64121B",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M468.866,327.253 l0.53,4.471c0.223,1.884-1.446,3.444-3.311,3.092l-3.744-0.06c-0.588-0.01-1.011-0.567-0.863-1.136l1.505-5.766L468.866,327.253z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_589_",
    style: {
      fill: "#64121B",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M470.033,346.385 l-5.473-12.145l-1.976,0.291c-0.696,0.102-1.096,0.848-0.796,1.484l3.341,7.093L470.033,346.385L470.033,346.385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M432.144,324.151 l6.043,14.387l8.518,16.971c0,0,2.962,6.896-4.538,9.939c-5.682,2.305-11.905-0.283-15.669-5.901 c-2.186-3.262-7.07-11.189-7.07-11.189l-3.091-1.815c-0.395-0.162-0.733-0.437-0.971-0.792l-4.683-6.984 c-0.261-0.389-0.388-0.854-0.36-1.322l0.365-6.242L432.144,324.151z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_559_",
    style: {
      fill: "#64121B",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M416.751,329.617 l1.194,4.341c0.503,1.829-0.914,3.621-2.81,3.553l-3.711,0.502c-0.582,0.079-1.085-0.409-1.023-0.994l0.624-5.927L416.751,329.617 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_557_",
    style: {
      fill: "#64121B",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeMiterlimit: 10
    },
    d: "M419.941,349.19 l-6.4-12.019l-1.91,0.584c-0.673,0.206-0.956,1.003-0.564,1.587l4.366,6.512L419.941,349.19"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_562_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 424.076,
    y1: 336.206,
    x2: 434.741,
    y2: 332.164
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_590_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 426.105,
    y1: 339.705,
    x2: 436.771,
    y2: 335.662
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_591_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 427.544,
    y1: 343.419,
    x2: 438.209,
    y2: 339.376
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_609_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 475.025,
    y1: 333.603,
    x2: 486.177,
    y2: 331.204
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_593_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 476.507,
    y1: 337.366,
    x2: 487.659,
    y2: 334.967
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_592_",
    style: {
      fill: "#891F38",
      stroke: "#64121A",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 477.373,
    y1: 341.254,
    x2: 488.524,
    y2: 338.855
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    style: {
      fill: "#64121A"
    },
    d: "M440.542,132.205c-0.085,0.876-0.865,1.518-1.741,1.432 c-0.876-0.085-1.518-0.865-1.432-1.741c0.085-0.876,0.865-1.518,1.741-1.432C439.986,130.549,440.627,131.329,440.542,132.205z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_536_",
    style: {
      fill: "#64121A"
    },
    d: "M454.155,141.959c-0.085,0.876-0.865,1.518-1.741,1.432 c-0.876-0.085-1.518-0.865-1.432-1.741c0.085-0.876,0.865-1.518,1.741-1.432C453.6,140.303,454.241,141.082,454.155,141.959z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_476_",
    style: {
      fill: "#D85656",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M660.038,770.42l-77.866,32.179c-0.181,0.061-0.381,0.012-0.514-0.126l-32.795-15.469V770.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_488_",
    style: {
      fill: "#F27575",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 660.038,770.42 548.863,770.42 581.875,787.004 693.049,787.004  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_474_",
    style: {
      fill: "#F7F0ED"
    },
    points: "693.003,802.625 581.829,802.625 608.168,813.234 719.342,813.234  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    style: {
      fill: "#C63E3E",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M693.049,802.698H582.423c-0.302,0-0.548-0.245-0.548-0.548v-15.146H692.26c0.436,0,0.79,0.354,0.79,0.79V802.698z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_388_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_477_",
    style: {
      fill: "#F27575",
      stroke: "#751225",
      strokeWidth: 6.2974,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 628.834,
    y1: 797.113,
    x2: 623.081,
    y2: 794.851
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_478_",
    style: {
      fill: "#F27575",
      stroke: "#751225",
      strokeWidth: 6.2974,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 660.705,
    y1: 797.113,
    x2: 655.618,
    y2: 794.406
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_430_",
    style: {
      fill: "#F27575",
      stroke: "#640917",
      strokeWidth: 6.2974,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 660.705,
    y1: 797.113,
    x2: 628.78,
    y2: 797.113
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    style: {
      fill: "none",
      stroke: "#640917",
      strokeWidth: 1.7993,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M407.549,155.72l-7.415-8.086l5.234-9.392c0,0-1.02-8.004,3.082-14.604"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligance2);
export default __webpack_public_path__ + "static/media/Intelligance2.a54fb5c3de97c204953bc8775aa40c9b.svg";
export { ForwardRef as ReactComponent };